var scope_0 = require('/home/travis/build/nejcm/docz-theme-extended/demo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/090cf9e023cc4e99ecc93fe89bc3b912.js').default;

var scope_1 = require('/home/travis/build/nejcm/docz-theme-extended/demo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/13fdd53cc91b4faa707ca06be09e2245.js').default;

var scope_2 = require('/home/travis/build/nejcm/docz-theme-extended/demo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/326bfbea02945b594459033981a9421d.js').default;

var scope_3 = require('/home/travis/build/nejcm/docz-theme-extended/demo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4fa6c530f71e48bdbd47bd5f34911040.js').default;

var scope_4 = require('/home/travis/build/nejcm/docz-theme-extended/demo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5b355cec21a9665db9566fbcbbc49345.js').default;

var scope_5 = require('/home/travis/build/nejcm/docz-theme-extended/demo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6120ea6fc29f94e1e9d36b12f0312e1f.js').default;

var scope_6 = require('/home/travis/build/nejcm/docz-theme-extended/demo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/65a6bfff44ac51121f641cb4d18e9a30.js').default;

var scope_7 = require('/home/travis/build/nejcm/docz-theme-extended/demo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7535e8a862151b6bc7533e73b6749c5e.js').default;

var scope_8 = require('/home/travis/build/nejcm/docz-theme-extended/demo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dd7034fa05770618cdd409f91fdbdefe.js').default;

var scope_9 = require('/home/travis/build/nejcm/docz-theme-extended/demo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var scope_10 = require('/home/travis/build/nejcm/docz-theme-extended/demo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/edfc3e7116af29fb539f3b2e77a89247.js').default;

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "../node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "../node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}